const getRequestUrl = (fetchInput: RequestInfo | URL): string =>
	typeof fetchInput === 'string'
		? fetchInput
		: fetchInput instanceof URL
			? fetchInput.href
			: fetchInput.url;

export { getRequestUrl };
